import {
  parseVisualGameAdminBillingActionPolicy,
  parseVisualGameAdminBillingDashboard,
  parseVisualGameAdminBillingLedgerPage,
  parseVisualGameAdminBillingOrderPage,
  parseVisualGameAdminBillingPolicyList,
  parseVisualGameAdminBillingProduct,
  parseVisualGameAdminBillingProductList,
  parseSignupRewardOffer,
} from '@drama/contracts'

export function createCommerceApi(transport) {
  return {
    summary() { return transport.request('GET', '/api/sk/billing/summary') },
    dailyClaim() { return transport.request('POST', '/api/sk/billing/daily-claim', { body: {} }) },
    // 公开：未登录的注册入口据此展示「注册送多少积分」
    signupReward() { return transport.request('GET', '/api/sk/billing/signup-reward', { public: true, parse: parseSignupRewardOffer }) },
    listAdminActionPolicies() { return transport.request('GET', '/api/admin/billing/action-policies', { parse: parseVisualGameAdminBillingPolicyList }) },
    updateAdminActionPolicy(action, body) { return transport.request('PATCH', `/api/admin/billing/action-policies/${encodeURIComponent(action)}`, { body, parse: parseVisualGameAdminBillingActionPolicy }) },
    listAdminProducts() { return transport.request('GET', '/api/admin/billing/products', { parse: parseVisualGameAdminBillingProductList }) },
    updateAdminProduct(id, body) { return transport.request('PATCH', `/api/admin/billing/products/${encodeURIComponent(id)}`, { body, parse: parseVisualGameAdminBillingProduct }) },
    listAdminOrders(query) { return transport.request('GET', '/api/admin/billing/orders', { query, parse: parseVisualGameAdminBillingOrderPage }) },
    adminDashboard(query) { return transport.request('GET', '/api/admin/billing/dashboard', { query, parse: parseVisualGameAdminBillingDashboard }) },
    listAdminLedger(query) { return transport.request('GET', '/api/admin/billing/ledger', { query, parse: parseVisualGameAdminBillingLedgerPage }) },
  }
}
